import React from 'react'
import { Form, Select } from 'antd'

export type FilterProposalProductProps = {
  onChange: Function
}

function FilterProposalProduct ({ onChange }: FilterProposalProductProps) {
  return (
    <Form.Item
      name='isRefinancing'
      key='isRefinancing'
      label={<label>Produto</label>}
    >
      <Select
        allowClear
        className='w-100'
        onChange={(value: any) => {
          onChange(value)
        }}
        placeholder='Novo contrato ou refinanciamento'
      >
        <Select.Option value=''>Todos</Select.Option>
        <Select.Option value='false'>Novo contrato</Select.Option>
        <Select.Option value='true'>Refinanciamento</Select.Option>
      </Select>
    </Form.Item>
  )
}

export default FilterProposalProduct
